import { render, staticRenderFns } from "./ShowClients.vue?vue&type=template&id=3067b2eb&scoped=true"
import script from "./ShowClients.vue?vue&type=script&lang=js"
export * from "./ShowClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3067b2eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3067b2eb')) {
      api.createRecord('3067b2eb', component.options)
    } else {
      api.reload('3067b2eb', component.options)
    }
    module.hot.accept("./ShowClients.vue?vue&type=template&id=3067b2eb&scoped=true", function () {
      api.rerender('3067b2eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/ShowClients.vue"
export default component.exports